module.exports = __webpack_public_path__ + "img/04.1a4c27bb.jpg";